<div class="container">
  <div class="header">
    <div class="title">Rechercher un profil</div>
    <div (click)="close()" class="close-btn">
      <mat-icon class="icon">close</mat-icon>
    </div>
  </div>
  <div class="description">
    <div fxFlex="100%">
      <app-text-input
        placeholder="Rechercher un profil"
        icon="search"
        iconType="mat-icon"
        (onKeyUp)="doFilter($event)"
      ></app-text-input>
    </div>
  </div>
  <div *ngIf="isLoading" class="center-flex spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div
    class="annuaire-container"
    [ngClass]="{ 'no-scroll-bar': (profiles?.length ?? 0) < 5 }"
    (scroll)="onScroll($event)"
    *ngIf="!isLoading"
    fxLayoutAlign="start"
  >
    <div class="card-container mg-b-20" fxLayout="column" *ngFor="let profile of profiles">
      <div fxLayout="row" fxLayoutAlign="space-between">
        <div class="mg-r-10">
          <app-smart-op-avatar [profile]="profile" [isAnnuaire]="true"></app-smart-op-avatar>
        </div>
        <div
          [ngClass]="{
            'primary-color cursor': !isInMessagerie && profile.position !== 'Chirurgien',
            'dark-medium-color disable-btn': isInMessagerie || profile.position === 'Chirurgien',
          }"
        >
          <div (click)="goToMessagerie(profile)">
            <div class="field-info" fxLayout="row" fxLayoutAlign="flex-end">
              <mat-icon>messenger</mat-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="redirection-buttons">
        <div class="mg-t-8">
          <app-button
            [disabled]="profile.shouldDisableProfileButton ?? false"
            (click)="goToPage(profile, '/profiles/')"
            text="Calendrier"
            btnType="outlined"
          ></app-button>
        </div>
        <div *ngIf="profile.position !== 'Chirurgien' && profile.position !== 'Cadre de bloc'" class="mg-t-8">
          <app-button
            [disabled]="profile.shouldDisableSmartplanningButton ?? false"
            (click)="goToPage(profile, '/smart-planning/my-program/')"
            text="SmartPlanning"
            btnType="outlined"
          ></app-button>
        </div>
        <div
          *ngIf="
            profile.position !== 'Chirurgien' &&
            profile.position !== 'Cadre de bloc' &&
            profile.position !== 'Anesthésiste'
          "
          class="mg-t-8"
        >
          <app-button
            [disabled]="profile.shouldDisableSkillsButton ?? false"
            (click)="goToPage(profile, '/parcours-ibode/competence/competence-individuelle/')"
            class="mg-t-8"
            [text]="hasSkills(profile.position)"
            btnType="outlined"
          ></app-button>
        </div>
        <div *ngIf="profile.position === 'Chirurgien' || profile.position === 'Anesthésiste'" class="mg-t-8">
          <app-button
            [disabled]="profile.shouldDisableStatopButton ?? false"
            (click)="
              profile.position === 'Chirurgien'
                ? goToPage(profile, '/statop/bloc/par-praticien/')
                : goToPage(profile, '/statop/anesthesiste/par-anesthesiste/')
            "
            class="mg-t-8"
            text="Statistiques"
            btnType="outlined"
          ></app-button>
        </div>
        <div *ngIf="profile.position !== 'Chirurgien' && profile.position !== 'Cadre de bloc'" class="mg-t-8">
          <app-button
            [disabled]="profile.shouldDisableJobDescriptionButton ?? false"
            (click)="goToPage(profile, '/configuration/advanced/fiche-poste/')"
            text="Fiche de poste"
            btnType="outlined"
          ></app-button>
        </div>
      </div>
      <div
        *ngIf="profile && profile.phoneNumber"
        class="field"
        [matTooltip]="profile.phoneNumber && profile.phoneNumber.length > 22 ? profile.phoneNumber : null"
      >
        <div fxLayout="row">
          <mat-icon>phone</mat-icon>
          Téléphone:
          {{
            profile.phoneNumber && profile.phoneNumber.length > 22
              ? profile.phoneNumber.substr(0, 22) + '...'
              : profile.phoneNumber
          }}
        </div>
      </div>
      <div
        *ngIf="getEmailByUserOrProfile(profile)"
        class="field"
        [matTooltip]="getEmailByUserOrProfileTooltip(profile)"
      >
        <div>
          <div fxLayout="row">
            <mat-icon>mail</mat-icon>
            E-mail: {{ getEmailByUserOrProfile(profile) }}
          </div>
        </div>
      </div>
    </div>
    <div fxFlex="100%" class="center-flex" *ngIf="!isLoading && profiles?.length === 0">Aucun profil trouvé.</div>
    <div fxFlex="100%" *ngIf="scrollLoading" class="spinner center-flex">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
